<!-- The details button sits next to the toggle rather than inside it: a button inside a button is
     invalid HTML, and it would make opening the details pick the row as well.
     The classes carry the component prefix because the styles are unencapsulated and Bootstrap,
     which is global, owns plain names such as .row and .label. -->
<button class="link-item-row" type="button" [attr.aria-pressed]="selected()" (click)="toggle()">
    <span class="link-item-label">{{ label() }}</span>
</button>
<cerrix-icon-button
    class="link-item-open"
    icon="link-external"
    [ariaLabel]="openAriaLabel()"
    [showBorder]="false"
    (click)="detailsRequested.emit()"
/>
